import { QueryResources, QueryResourcesInfinite } from 'datx-jsonapi-react';

import { ProfilePlaylist } from '@/resources/ProfilePlaylist';
import { ThinProfile } from '@/resources/ThinProfile';

export const queryProfilePlaylistsInfinite = (profileId, pageSize = 16): QueryResourcesInfinite<ProfilePlaylist> => {
  return (pageIndex) => {
    const pageNumber = pageIndex + 1;

    return [
      `${ThinProfile.type}/${profileId}/playlists`,
      {
        params: [
          {
            key: 'page[size]',
            value: pageSize.toString(),
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};

export const queryProfilePlaylists = (profileId: string): QueryResources<ProfilePlaylist> => {
  if (!profileId) return null;
  return [
    `${ThinProfile.type}/${profileId}/playlists`,
    {
      params: [
        {
          key: 'page[size]',
          value: '100',
        },
      ],
    },
  ];
};
